import React from 'react';

import BaseOAuthButton from './BaseOAuthButton';

import Icon from '../assets/microsoft.svg';
import { BaseOAuthProps } from '../types';

const MicrosoftOAuthButton: React.FC<BaseOAuthProps> = (props) => {
    return <BaseOAuthButton {...props} label="Microsoft" apiUrl="/api/v3/oauth/microsoft" icon={<Icon />} />;
};

export default MicrosoftOAuthButton;
